export default "__VITE_ASSET__ff5ba817__"